export default 'buildingPage';
